<script>
  import { useUrlParams } from "@stores/urlStore.js";
  import { onMount } from "svelte";
  import {
    Button,
    ProgressIndicator,
    ProgressStep,
    Modal as DangerModal,
    TextArea,
  } from "carbon-components-svelte";

  import Scoping from "./Project/Scoping.svelte";
  import SoftwareLandscape from "./Project/SoftwareLandscape.svelte";
  import AnonymizationRules from "./Project/AnonymizationRules.svelte";
  import MainRecording from "./Project/MainRecording.svelte";
  import PreviousOutline20 from "carbon-icons-svelte/lib/PreviousOutline20";
  import CheckmarkOutline20 from "carbon-icons-svelte/lib/CheckmarkOutline20";
  import { fly } from "svelte/transition";

  import Header from "../../../lib/components/Header.svelte";
  import ButtonNew from "../../../lib/components/ButtonNew.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { STOP_RECORDING_PAUSE_MESSAGES } from "./Project/phaseMessages.js";

  const urlParams = useUrlParams();

  $: ({ idproject, currentStep } = $urlParams);

  let stepsCompleted = [false, false, false, false];
  let steps = [
    "Project Setup",
    "Application Scope",
    "Anonymization Rules",
    "Main Recording",
  ];
  let openDangerModal = false;
  // Plain text the recorder shows in its menu once recording is stopped (config PauseRecordingMessage).
  let stopPauseMessage = STOP_RECORDING_PAUSE_MESSAGES.en;

  function goStep(step) {
    if (step === 0 || stepsCompleted[step] || stepsCompleted[step - 1]) {
      urlParams.updateParam("currentStep", step);
    }
  }

  // function nextStepAfterCompletion(stepsCompleted)
  // {
  //   if(stepsCompleted[0])
  //     currentStep += 1;
  // }
  // $:{
  //   nextStepAfterCompletion(stepsCompleted)
  // }
  onMount(() => {
    fetchWithSession(`/api/damprojects/DAMProject/${idproject}/progress`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        //currentStep = 0
        data.forEach((step) => {
          stepsCompleted[step.step] = step.completed;
          // if(step.completed)
          //  currentStep = step.step;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  });

  let stopSuccessNotification = false;
  let deduplicateNotification = false;

  function stopRecording() {
    fetchWithSession(`/api/damprojects/stopRecording`, {
      method: "POST",
      body: JSON.stringify({
        idproject: idproject,
        pauseMessage: stopPauseMessage,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        stopSuccessNotification = true;
        window.setTimeout(() => {
          stopSuccessNotification = false;
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function deduplicateData() {
    fetchWithSession(`/api/damprojects/deduplicateDataset`, {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        deduplicateNotification = true;
        window.setTimeout(() => {
          deduplicateNotification = false;
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  $$restProps;
</script>

{#if stopSuccessNotification}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; top:50px; right:0px; z-index:100;"
  >
  </div>
{/if}

{#if deduplicateNotification}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; top:50px; right:0px; z-index:100;"
  >
  </div>
{/if}
<Header section="Project" breadcrumb="Settings">
  <ButtonNew
    text="Setup"
    iconLeft={stepsCompleted[0]}
    icon="check"
    setting={true}
    secondary={true}
    on:click={() => {
      goStep(0);
    }}
  />
  <ButtonNew
    text="Scope"
    iconLeft={stepsCompleted[1]}
    icon="check"
    setting={true}
    secondary={true}
    on:click={() => {
      goStep(1);
    }}
  />
  <ButtonNew
    text="Anonymization"
    iconLeft={stepsCompleted[2]}
    icon="check"
    setting={true}
    secondary={true}
    on:click={() => {
      goStep(2);
    }}
  />

  {#if currentStep == 3 || stepsCompleted[3]}
    <ButtonNew
      text="Complete"
      setting={true}
      disabled={true}
      secondary={true}
    />
  {:else}
    <ButtonNew
      text="Complete"
      secondary={true}
      setting={true}
      on:click={() => {
        goStep(3);
      }}
    />
  {/if}

  <ButtonNew
    text="Stop Recording"
    setting={true}
    secondary={true}
    on:click={() => {
      openDangerModal = true;
    }}
  />

  <ButtonNew
    text="Deduplicate Data"
    setting={true}
    secondary={true}
    on:click={() => {
      deduplicateData();
    }}
  />

  <!-- @Adrian back hab ich erstmal ausgeblendet -->
  <!-- <ButtonNew text="Back" url="/app/dam/" secondary={true} /> -->
</Header>

<!-- @Adrian den Indikator hab ich durch die Buttons oben ersetzt -->
<!-- {#key stepsCompleted}
  <ProgressIndicator
    spaceEqually
    currentIndex={currentStep}
    preventChangeOnClick
  >
    <ProgressStep
      complete={stepsCompleted[0]}
      label="Project Setup"
      on:click={() => {
        goStep(0);
      }}
    />
    <ProgressStep
      complete={stepsCompleted[1]}
      label="Application Scope"
      on:click={() => {
        goStep(1);
      }}
    />
    <ProgressStep
      complete={stepsCompleted[2]}
      label="Anonymization Rules"
      on:click={() => {
        goStep(2);
      }}

@Adrian den Check ganz rechts hab ich durch "Complete" oben rechts ersetzt
    <div
      class={currentStep == 3 || stepsCompleted[3]
        ? "completed"
        : "uncompleted"}
      on:click={() => {
        goStep(3);
      }}
    >
      <CheckmarkOutline20 />
    </div>
  </ProgressIndicator>
{/key} -->

<!-- {#if steps[currentStep] == "Project Setup"}
  <ProjectSetup idproject={idproject} bind:isCompleted = {stepsCompleted[0]}/>
  {/if} -->
{#if steps[currentStep] == "Project Setup"}
  <Scoping bind:isCompleted={stepsCompleted[0]} />
{/if}
{#if steps[currentStep] == "Application Scope"}
  <SoftwareLandscape bind:isCompleted={stepsCompleted[1]} />
{/if}
{#if steps[currentStep] == "Anonymization Rules"}
  <AnonymizationRules bind:isCompleted={stepsCompleted[2]} />
{/if}
{#if steps[currentStep] == "Main Recording"}
  <MainRecording bind:isCompleted={stepsCompleted[4]} />
{/if}

<DangerModal
  danger
  bind:open={openDangerModal}
  modalHeading={`Stop Recording`}
  primaryButtonText="Stop Recording"
  preventCloseOnClickOutside
  secondaryButtonText="Cancel"
  on:click:button--primary={() => {
    openDangerModal = false;
    stopRecording();
  }}
  on:click:button--secondary={() => (openDangerModal = false)}
  on:close={() => (openDangerModal = false)}
>
  <p class="deleteModalBody">
    Are you sure you want to stop the recording?
    <span>This action cannot be undone.</span>
  </p>
  <TextArea
    labelText="Pause Message"
    helperText="Plain text shown in the recorder menu after the recording has stopped. Leave empty for the recorder's default text."
    placeholder="Enter the text shown after the recording has stopped"
    rows={3}
    bind:value={stopPauseMessage}
  />
</DangerModal>

<!-- {#if steps[currentStep] == "Process Analysis" }
  <AnalysisLauncher  bind:isCompleted = {stepsCompleted[5]}/>
  {/if} -->

<style>
  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }

  .deleteModalBody span {
    font-weight: 700;
  }

  .deleteModalBody :last-child {
    color: var(--pax-orange);
  }

  /* .completed {
    border-top: 2px solid #ff5f1f;
    color: #ff5f1f;
  }

  .uncompleted {
    border-top: 2px solid white;
  } */
</style>
